new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: 0,
    listExMobile: 2
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#DADADA', '#000', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#DADADA', '#000', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#DADADA', '#000', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();

    // About themes: truncar a 400px de altura com Ver mais/Ver menos
    (function () {
      const MAX_HEIGHT = 400;

      function setupAboutThemesToggle(container) {
        const originalHTML = container.getAttribute('data-original-html') || container.innerHTML;
        
        // Criar elemento temporário para medir a altura
        const tempWrapper = document.createElement('div');
        tempWrapper.style.position = 'absolute';
        tempWrapper.style.visibility = 'hidden';
        tempWrapper.style.width = container.offsetWidth + 'px';
        tempWrapper.innerHTML = originalHTML;
        document.body.appendChild(tempWrapper);
        
        const fullHeight = tempWrapper.offsetHeight;
        document.body.removeChild(tempWrapper);

        // Se a altura for menor ou igual a 400px, não precisa fazer nada
        if (fullHeight <= MAX_HEIGHT) {
          container.setAttribute('data-original-html', originalHTML);
          return;
        }

        container.setAttribute('data-original-html', originalHTML);
        container.style.maxHeight = MAX_HEIGHT + 'px';
        container.style.overflow = 'hidden';
        container.classList.add('about-themes-collapsed');

        const toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'about-themes-toggle';
        toggleBtn.textContent = 'Ver mais';

        toggleBtn.addEventListener('click', function () {
          const isExpanded = !container.classList.contains('about-themes-collapsed');
          
          if (isExpanded) {
            // Colapsar
            container.style.maxHeight = MAX_HEIGHT + 'px';
            container.style.overflow = 'hidden';
            container.classList.add('about-themes-collapsed');
            toggleBtn.textContent = 'Ver mais';
          } else {
            // Expandir - usar altura grande suficiente ou 'none' para remover limitação
            container.style.maxHeight = '';
            container.style.overflow = '';
            container.classList.remove('about-themes-collapsed');
            toggleBtn.textContent = 'Ver menos';
          }
        });

        // Inserir o botão após o container, não dentro dele
        container.parentNode.insertBefore(toggleBtn, container.nextSibling);
      }

      function initAboutThemes() {
        const nodes = document.querySelectorAll('.about-themes-content');
        if (!nodes || nodes.length === 0) return;
        nodes.forEach(setupAboutThemesToggle);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAboutThemes);
      } else {
        initAboutThemes();
      }
    })();
  },
  watch: {
    menuFilter(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    listOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});